export default "__VITE_ASSET__573ec1d1__"